import { type PropsWithChildren } from "react";
import LoadingLogoCubes from "@/components/atoms/loadingLogoCubes";

/**
 * Full-viewport loading state (auth, profile, shell chunk, or RouterProvider suspend).
 * Use {@link PageLoadingFallback} only inside the main content / outlet region.
 */
const ProfileLoadingScreen = ({ children }: PropsWithChildren) => {
  return (
    <div
      className="
        flex min-h-screen flex-col items-center justify-center gap-4 bg-page-bg
      "
    >
      <LoadingLogoCubes className="h-40 animate-bounce opacity-20 [animation-duration:1s]" />
      {children}
    </div>
  );
};

export default ProfileLoadingScreen;
